query allHockeyTeams($first: Int, $offset: Int, $filter: HockeyTeamFilter) {
  teams: allHockeyTeams(first: $first, offset: $offset, filter: $filter) {
    nodes {
      teamMappings: hockeyTeamMappingsByIntId {
        nodes {
          extId
          extRef
          feed
          mappingId
          mappingType
          createdAt
          createdBy
          updatedAt
          updatedBy
        }
      }
      name
      source
      teamId
    }
    totalCount
  }
}
